import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore } from 'redux-persist'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { syncTranslationWithStore } from 'react-redux-i18n'

import persistedReducer from './reducers'

const isProduction = process.env.REACT_APP_ENV === 'production'
const isJestVerbose = process.env.JEST_VERBOSE === 'true'

const logger = createLogger({
  collapsed: true,
})

const composeEnhancers = !isProduction && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

const middleware = (!isProduction && !isJestVerbose) ? [thunk, logger] : [thunk]

const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleware)))

const persistor = persistStore(store)

syncTranslationWithStore(store)

export { store, persistor }
